<button
  odxButton
  variant="secondary"
  (click)="onClickDuplicate()"
  [odxTooltip]="tooltipTextDuplicateItem"
  [disabled]="(hasWritePermission$ | async) === false"
>
  <odx-icon name="copy-content" size="medium"></odx-icon>
</button>
